import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, use, useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from '../ui/components/select.js';
const ActiveSampleContext = createContext('');
export function Samples({ items, defaultValue = items[0].value, children, }) {
    const [value, setValue] = useState('');
    const active = value === '' ? defaultValue : value;
    const defaultItem = items.find((item) => item.value === defaultValue);
    return (_jsxs(_Fragment, { children: [_jsxs(Select, { value: value, onValueChange: setValue, children: [_jsx(SelectTrigger, { className: "not-prose mb-2", children: _jsx(SelectValue, { placeholder: defaultItem ? _jsx(SelectDisplay, { ...defaultItem }) : null }) }), _jsx(SelectContent, { children: items.map((item) => (_jsx(SelectItem, { value: item.value, children: _jsx(SelectDisplay, { ...item }) }, item.value))) })] }), _jsx(ActiveSampleContext, { value: active, children: children })] }));
}
function SelectDisplay(item) {
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "font-medium text-sm", children: item.title }), _jsx("span", { className: "text-fd-muted-foreground", children: item.description })] }));
}
export function Sample({ value, children }) {
    const active = use(ActiveSampleContext);
    if (value !== active)
        return;
    return children;
}
